import { Component, OnInit } from '@angular/core';
import { FingerDevicesService } from '../finger-devices.service';
import notify from 'devextreme/ui/notify';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-import-finger-print',
  templateUrl: './import-finger-print.component.html',
  styleUrls: ['./import-finger-print.component.scss']
})
export class ImportFingerPrintComponent implements OnInit {

  attendingData: any[] = [];
  devices: any[] = [];
  workDurations: any[] = [];
  isSaving: boolean = false;

  // ⭐ Bulk Upload Properties
  isUploadingBulk: boolean = false;
  bulkResults: any = null;

  formData: any = {
    fromDate: new Date(),
    printDeviceId: null,
    workDuration: null,
    toDate: new Date()
  };

  constructor(private _FingerDevicesService: FingerDevicesService) {}

  ngOnInit(): void {
    this._FingerDevicesService.getDurationWorkSystemDropDown().subscribe({
      next: (data) => {
        console.log('Work Durations:', data);
        this.workDurations = data;
      },
      error: (err) => {
        console.error(err);
      }
    });

    this._FingerDevicesService.GetDeviceAttendancesdropdown().subscribe({
      next: (data) => {
        console.log('Devices:', data);
        this.devices = data;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  timeAttendingCell = (rowData: any) => {
    return rowData.timeAttending ? rowData.timeAttending : 'لم يتم بصم حضور';
  }

  timeLeaveCell = (rowData: any) => {
    return rowData.timeLeave ? rowData.timeLeave : 'لم يتم بصم انصراف';
  }

  saveAttendanceData() {
    if (!this.attendingData || this.attendingData.length === 0) {
      notify('لا توجد بيانات للحفظ', 'warning', 3000);
      return;
    }

    const dataToSave = this.attendingData
      .filter(item => item.employeeIdfromEmployyeTable != 0)
      .map(item => ({
        employeeId: item.employeeIdfromEmployyeTable,
        dateOfDay: item.dateOfDay,
        timeAttending: item.timeAttending,
        timeLeave: item.timeLeave,
        durationWorkSystemId: item.durationWorkSystemId || this.formData.workDuration,
        attending_LeavingType:
          (item.timeAttending && item.timeLeave) ? 3 :
          (item.timeAttending ? 1 : 2),
        description: item.description || `حضور يوم ${item.dateOfDay}`
      }));

    console.log('Data to save:', dataToSave);

    this.isSaving = true;

    this._FingerDevicesService.saveAttendanceData(dataToSave)
      .subscribe({
        next: (response) => {
          console.log('Save Response:', response);
          notify('تم حفظ البيانات بنجاح', 'success', 3000);
          this.isSaving = false;
        },
        error: (err) => {
          console.error('Save Error:', err);
          notify('حدث خطأ أثناء حفظ البيانات', 'error', 3000);
          this.isSaving = false;
        }
      });
  }

  onFormSubmit() {
    const requestData = {
      fromDate: this.formData.fromDate,
      printDeviceId: this.formData.printDeviceId,
      workDuration: this.formData.workDuration,
      toDate:this.formData.toDate
    };

    console.log('Request:', requestData);

    this._FingerDevicesService.importFingerServices(requestData)
      .subscribe({
        next: (data) => {
          console.log('Response:', data);
          this.attendingData = data;
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  // =============================
  // ⭐ Bulk Upload Functions
  // =============================

  triggerUpload() {
    document.getElementById('excelUploadAttendance')!.click();
  }

  onFileUploaded(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const rawData: any[] = XLSX.utils.sheet_to_json(worksheet);

      if (rawData.length === 0) {
        notify('الملف فارغ!', 'warning', 3000);
        return;
      }

      // ⭐ تحويل البيانات
      const items = rawData.map((row: any) => ({
        employeeName: row['EmployeeName'] || row['اسم الموظف'] || '',
        dateOfDay: this.formatExcelDate(row['Date'] || row['التاريخ']),
        timeAttending: this.parseTime(row['TimeAttending'] || row['وقت الحضور']),
        timeLeave: this.parseTime(row['TimeLeave'] || row['وقت الانصراف'])
      }));

      this.uploadBulk(items);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = '';
  }

  // ⭐ تحويل التاريخ من Excel
  formatExcelDate(excelDate: any): string {
    if (!excelDate) return new Date().toISOString();

    if (typeof excelDate === 'number') {
      return new Date((excelDate - 25569) * 86400 * 1000).toISOString();
    }

    if (typeof excelDate === 'string') {
      const parts = excelDate.split('/');
      if (parts.length === 3) {
        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).toISOString();
      }
    }

    return new Date(excelDate).toISOString();
  }

  // ⭐ تحويل الوقت من Excel
  parseTime(timeValue: any): string | null {
    if (!timeValue) return null;

    // لو رقم (Excel Time Format: 0.333 = 8:00)
    if (typeof timeValue === 'number') {
      const totalSeconds = Math.round(timeValue * 24 * 60 * 60);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    // لو نص (08:00 أو 08:00:00)
    if (typeof timeValue === 'string') {
      const parts = timeValue.split(':');
      if (parts.length === 2) {
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:00`;
      }
      if (parts.length === 3) {
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
      }
    }

    return timeValue.toString();
  }

  uploadBulk(items: any[]) {
    this.isUploadingBulk = true;
    this.bulkResults = null;

    this._FingerDevicesService.AddBulk({ items }).subscribe({
      next: (res: any) => {
        this.bulkResults = res;
        this.isUploadingBulk = false;

        if (res.failedCount === 0) {
          notify('تم رفع جميع السجلات بنجاح', 'success', 3000);
        } else {
          notify(
            `تم رفع ${res.successCount} سجل، فشل ${res.failedCount} سجل`,
            'warning',
            5000
          );
        }
      },
      error: (err) => {
        this.isUploadingBulk = false;
        notify('حدث خطأ أثناء الرفع الجماعي', 'error', 3000);
        console.error(err);
      }
    });
  }

  exportFailedRows() {
    if (!this.bulkResults?.errors?.length) {
      notify('لا توجد أخطاء للتصدير', 'info', 2000);
      return;
    }

    const failedData = this.bulkResults.errors.map((error: any) => ({
      'السطر': error.rowIndex,
      'اسم الموظف': error.employeeName || '',
      'التاريخ': error.dateOfDay 
        ? new Date(error.dateOfDay).toLocaleDateString('ar-EG') 
        : '',
      'الأخطاء': error.errors.join(', ')
    }));

    const ws = XLSX.utils.json_to_sheet(failedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'الأخطاء');

    ws['!cols'] = [
      { wch: 10 },
      { wch: 25 },
      { wch: 15 },
      { wch: 60 }
    ];

    XLSX.writeFile(wb, 'حضور_فاشل_لإعادة_التعديل.xlsx');
    notify('تم تصدير الأخطاء بنجاح', 'success', 2000);
  }

  downloadTemplate() {
    const template = [
      {
        'اسم الموظف': 'أحمد محمد',
        'التاريخ': '15/01/2024',
        'وقت الحضور': '08:00',
        'وقت الانصراف': '17:00'
      },
      {
        'اسم الموظف': 'محمد علي',
        'التاريخ': '15/01/2024',
        'وقت الحضور': '08:30',
        'وقت الانصراف': '16:45'
      }
    ];

    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'قالب الحضور والانصراف');

    ws['!cols'] = [
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 }
    ];

    XLSX.writeFile(wb, 'قالب_الحضور_والانصراف.xlsx');
    notify('تم تحميل القالب بنجاح', 'success', 2000);
  }
}